import { render, staticRenderFns } from "./SignifiLogs.vue?vue&type=template&id=20a7e669&scoped=true&"
import script from "./SignifiLogs.vue?vue&type=script&lang=js&"
export * from "./SignifiLogs.vue?vue&type=script&lang=js&"
import style0 from "./SignifiLogs.vue?vue&type=style&index=0&id=20a7e669&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a7e669",
  null
  
)

export default component.exports